/**
 * Race runner cards: card toggle, bet panel wiring, runner overflow, related strip arrows.
 * Shared by the race page and the expanded race card on /races/upcoming/
 * (racing/includes/race_runners.html), so clicks are delegated from document.
 */
import { toggleRunner, closeRunner, setExpanded, initRunnerHistory } from './runner_toggle.js';

(function () {
  'use strict';
  if (window.__tlRaceCardsBound) return;
  window.__tlRaceCardsBound = true;

  document.addEventListener('click', function (e) {
    if (!e.target.closest('.runner-list, .result-list, .rc-overflow')) return;
    _handleCardClick(e);
  });

  // Per-container overflow toggle (works for any number of races on a page)
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.rc-show-more[data-overflow-for]');
    if (!btn) return;
    e.stopPropagation();
    var scope = btn.parentElement;
    var ov = scope.querySelector('.rc-overflow[data-overflow-for="' + btn.dataset.overflowFor + '"]');
    if (!ov) return;
    var total = btn.textContent.match(/\d+/);
    var n = total ? total[0] : '';
    if (!btn.dataset.total) btn.dataset.total = n;
    if (ov.classList.toggle('open')) btn.innerHTML = 'Show top 5 only &#x2191;';
    else btn.innerHTML = 'Show all ' + btn.dataset.total + ' runners &#x2193;';
  });

  var list = document.querySelector('.race-page .runner-list')
          || document.querySelector('.race-page .result-list');
  var overflow = document.getElementById('v2Overflow-racepage');

  function _handleCardClick(e) {
    // Result card: click anywhere on .res-card toggles comment
    var resCard = e.target.closest('.res-card');
    if (resCard) {
      if (e.target.closest('a')) return; // don't intercept links
      if (document.documentElement.classList.contains('detail-core')) return;
      resCard.classList.toggle('expanded');
      return;
    }

    // Pre-race card: use data-action delegation
    var actionEl = e.target.closest('[data-action]');
    if (!actionEl) return;

    var card = actionEl.closest('.runner-card');
    if (!card) return;

    var action = actionEl.dataset.action;

    if (action === 'toggle') {
      if (e.target.closest('a')) return;
      // Accordion in every detail mode: one open card per .race-runners block.
      // History entries only on the single-race page (ids are unique there).
      toggleRunner(card, { push: !!card.closest('.race-page') });
    }

    if (action === 'close') {
      e.preventDefault();
      closeRunner(card);
    }

    if (action === 'bet') {
      e.preventDefault();
      if (TL.betting && TL.betting.openPanel) TL.betting.openPanel(card);
    }
  }

  // Keyboard: Enter/Space on the focused card header toggles it.
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var head = e.target.closest && e.target.closest('.rc-compact[data-action="toggle"]');
    if (!head || e.target !== head) return;
    e.preventDefault();
    var c = head.closest('.runner-card');
    if (c) toggleRunner(c, { push: !!c.closest('.race-page') });
  });

  initRunnerHistory();

  // ── Deep mode: auto-expand top-scored card ──
  if (list && document.documentElement.classList.contains('detail-deep')) {
    var topCard = list.querySelector('.runner-card.top-scored');
    if (topCard && !topCard.classList.contains('expanded')) {
      setExpanded(topCard, true);
    }
  }


  // ── Related strip scroll arrows ──
  var strip = document.getElementById('relatedStrip');
  var wrap = strip && strip.closest('.related-strip-wrap');
  if (strip && wrap) {
    var leftArr = wrap.querySelector('.strip-arrow.left');
    var rightArr = wrap.querySelector('.strip-arrow.right');

    function updateArrows() {
      var sl = strip.scrollLeft;
      var maxScroll = strip.scrollWidth - strip.clientWidth;

      if (maxScroll <= 2) {
        // Not scrollable
        wrap.className = 'related-strip-wrap';
        if (leftArr) leftArr.classList.remove('visible');
        if (rightArr) rightArr.classList.remove('visible');
        return;
      }

      if (sl <= 2) {
        wrap.className = 'related-strip-wrap scrolled-start';
        if (leftArr) leftArr.classList.remove('visible');
        if (rightArr) rightArr.classList.add('visible');
      } else if (sl >= maxScroll - 2) {
        wrap.className = 'related-strip-wrap scrolled-end';
        if (leftArr) leftArr.classList.add('visible');
        if (rightArr) rightArr.classList.remove('visible');
      } else {
        wrap.className = 'related-strip-wrap scrolled-mid';
        if (leftArr) leftArr.classList.add('visible');
        if (rightArr) rightArr.classList.add('visible');
      }
    }

    strip.addEventListener('scroll', updateArrows);
    window.addEventListener('resize', updateArrows);
    updateArrows();

    // Scroll to current race card
    var current = strip.querySelector('.rel-card.current');
    if (current) {
      var offset = current.offsetLeft - strip.offsetLeft - (strip.clientWidth / 2) + (current.offsetWidth / 2);
      strip.scrollLeft = Math.max(0, offset);
      // Re-check arrows after scrolling
      setTimeout(updateArrows, 50);
    }

    if (leftArr) {
      leftArr.addEventListener('click', function () {
        strip.scrollBy({ left: -200, behavior: 'smooth' });
      });
    }
    if (rightArr) {
      rightArr.addEventListener('click', function () {
        strip.scrollBy({ left: 200, behavior: 'smooth' });
      });
    }
  }
})();
